import React from 'react';
import { imgOt7_80x80NeonBgPatternWebp, imgOt7LogoBlackSvg } from '../images';
import { colorFromInt } from '../lib';
import { getHighSchoolYear, Ot7Player } from '../models/Ot7Player';
import { Ot7Team } from '../models/Ot7Team';
import Picture from '../overtime-lib/src/www/components/Picture';
import PhotoVideo from './PhotoVideo';
import './PlayerHighlight.scss';

const PlayerHighlight = ({
	ot7_player,
	ot7_team,
	imageType,
	logoBubbleText,
	thirdLineTextOverride,
}: {
	ot7_player: Partial<Ot7Player>;
	ot7_team: Ot7Team;
	imageType: 'player' | 'team';
	logoBubbleText?: string;
	thirdLineTextOverride?: string;
}) => {
	if (ot7_player === null && ot7_team === null) {
		return null;
	}
	imageType = ot7_player.image_path ? imageType : 'team';

	const thirdLineText =
		thirdLineTextOverride ||
		`${[
			imageType == 'player' && ot7_player.position ? ot7_player.position : null,
			ot7_player.graduation_year ? `${getHighSchoolYear(ot7_player.graduation_year)}` : null,
		]
			.filter(Boolean)
			.join(', ')}`;

	return (
		<div className="PlayerHighlight">
			<div className="Photos">
				<div
					className="Profile"
					style={{
						backgroundImage: `url(${imgOt7_80x80NeonBgPatternWebp})`,
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					{imageType == 'player' && (
						<>
							{ot7_player.image_path ? (
								<Picture src={ot7_player.image_path} alt={ot7_player.full_name} />
							) : (
								<img className="Placeholder" src={imgOt7LogoBlackSvg} alt="OT7 Logo" />
							)}
						</>
					)}
					{imageType == 'team' && (
						<PhotoVideo
							src={`https://images.overtime.tv/${ot7_team.logo_path}?width=300`}
							alt={ot7_player.full_name}
							mobileWidth={300}
							style={{
								backgroundColor: ot7_team.primary_color ? colorFromInt(ot7_team.primary_color) : '#fff',
								borderRadius: '50%',
								aspectRatio: '1',
							}}
						/>
					)}
				</div>

				<div className="Team">
					{logoBubbleText && <div className="PlayerPosition">{logoBubbleText}</div>}
					{!logoBubbleText && imageType == 'player' && (
						<Picture
							src={ot7_team.logo_path}
							alt={ot7_team.name}
							style={{ backgroundColor: colorFromInt(ot7_team?.primary_color) }}
						/>
					)}
					{!logoBubbleText && imageType == 'team' && <div className="PlayerPosition">{ot7_player.position}</div>}
				</div>
			</div>

			<div className="Info">
				<div className="Name">{ot7_player.full_name}</div>
				<a href={`/teams/${ot7_team.slug}`} className="Team">
					{ot7_team.name}
				</a>
				<div className="Position">{thirdLineText}</div>
			</div>
		</div>
	);
};

export default PlayerHighlight;
